import React from "react";

import { strings } from "@perceptron/constants";

import { useToolCallStore } from "@demo/store/tool-calls";

import { ToolCallEntryCard } from "./ToolCallEntryCard";

/**
 * Every tool call of the current run, in order of first appearance. Used when there is no
 * reasoning text to anchor the cards in; otherwise each round's cards render inline in the
 * thinking block through `ToolCallSlot`.
 */
export const ToolCallList: React.FC = () => {
  const order = useToolCallStore((state) => state.order);
  const calls = useToolCallStore((state) => state.calls);
  if (order.length === 0) return null;

  return (
    <section aria-label={strings.toolCall.sectionLabel} className="my-4 flex flex-col" data-testid="tool-call-list">
      {order.map((id) => {
        const call = calls[id];
        return call ? <ToolCallEntryCard call={call} key={id} /> : null;
      })}
    </section>
  );
};
